/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Learn_Mistakescount1Inputs */

const zh_learn_mistakescount1 = /** @type {(inputs: Learn_Mistakescount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 道错题`)
};

const en_learn_mistakescount1 = /** @type {(inputs: Learn_Mistakescount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} mistakes`)
};

const es_learn_mistakescount1 = /** @type {(inputs: Learn_Mistakescount1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} errores`)
};

/**
* | output |
* | --- |
* | "{count} mistakes" |
*
* @param {Learn_Mistakescount1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const learn_mistakescount1 = /** @type {((inputs: Learn_Mistakescount1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_Mistakescount1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_learn_mistakescount1(inputs)
	if (locale === "en") return en_learn_mistakescount1(inputs)
	return es_learn_mistakescount1(inputs)
});
export { learn_mistakescount1 as "learn_mistakesCount" }